import {
  ChevronLeftIcon,
  ChevronRightIcon,
  FontSizeEnum,
  IconSizeEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { useNavigationKeywords } from '@/features/broadcast-schedule-program/hooks/useNavigationKeywords';

export function ClipDetailNavigation() {
  const { activeClip, clipItems, setActiveClip, setVisibleBox } = useBroadcastScheduleProgram();
  const { t } = useTranslation();

  const hasNextItem = useMemo(() => {
    if (!activeClip) return false;
    return clipItems.findIndex(item => item.id === activeClip.id) !== clipItems.length - 1;
  }, [activeClip, clipItems]);

  const hasPreviousItem = useMemo(() => {
    if (!activeClip) return false;
    return clipItems.findIndex(item => item.id === activeClip.id) > 0;
  }, [activeClip, clipItems]);

  const handleNext = () => {
    setVisibleBox(null);

    if (!activeClip) return;
    const currentIndex = clipItems.findIndex(item => item.id === activeClip.id);

    if (currentIndex === -1 || currentIndex === clipItems.length - 1) return;

    const nextItem = clipItems[currentIndex + 1];

    if (nextItem) {
      setActiveClip(nextItem);
    }
  };

  const handlePrevious = () => {
    setVisibleBox(null);

    if (!activeClip) return;

    const currentIndex = clipItems.findIndex(item => item.id === activeClip.id);

    if (currentIndex === -1 || currentIndex === 0) return;

    const previousItem = clipItems[currentIndex - 1];

    if (previousItem) {
      setActiveClip(previousItem);
    }
  };

  useNavigationKeywords({
    handleClickNextUi: handleNext,
    handleClickPrevUi: handlePrevious,
    shortcutsDisabled: false,
  });

  return (
    <div
      className={clsx(
        'sticky bottom-0 flex justify-between bg-white py-2',
        !hasPreviousItem && '!justify-end'
      )}
    >
      {hasPreviousItem && (
        <div className="flex cursor-pointer items-center gap-2" onClick={handlePrevious}>
          <ChevronLeftIcon size={IconSizeEnum.SM} />
          <Typography fontSize={FontSizeEnum.Basic}>{t('Anterior')}</Typography>
        </div>
      )}
      {hasNextItem && (
        <div onClick={handleNext} className="flex cursor-pointer items-center justify-end gap-2">
          <Typography fontSize={FontSizeEnum.Basic}>{t('Siguiente')}</Typography>
          <ChevronRightIcon size={IconSizeEnum.SM} />
        </div>
      )}
    </div>
  );
}
